module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-primary"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Registrar un usuario nuevo")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "input-group form-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.name),
      expression: "newUser.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "tabindex": "2",
      "placeholder": "Nombre"
    },
    domProps: {
      "value": (_vm.newUser.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.username),
      expression: "newUser.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "tabindex": "2",
      "placeholder": "Usuario"
    },
    domProps: {
      "value": (_vm.newUser.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group form-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.password),
      expression: "newUser.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "tabindex": "2",
      "placeholder": "Clave"
    },
    domProps: {
      "value": (_vm.newUser.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group form-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.password2),
      expression: "newUser.password2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "tabindex": "2",
      "placeholder": "Confirmar clave"
    },
    domProps: {
      "value": (_vm.newUser.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "password2", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.email),
      expression: "newUser.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "tabindex": "2",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.newUser.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "homeform"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": _vm.validateFields
    }
  }, [_vm._v("Crear Usuario")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-italic glyphicon-tamano"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-user glyphicon-tamano"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-lock glyphicon-tamano"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-lock glyphicon-tamano"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon-tamano",
    staticStyle: {
      "font-weight": "bold",
      "font-size": "1.3em"
    }
  }, [_vm._v("@")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-05c02aa6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05c02aa6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/membership/Register.vue
// module id = 103
// module chunks = 0